import AddIcon from '@mui/icons-material/Add'
import { Button, FormLabel, Container } from '@mui/material'
import { get, flatten, difference } from 'lodash'
import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import RemoveLoadingHook from '../../hooks/RemoveLoadingHook'
import { useActions } from '../../hooks/useActions'
import { usePersons } from '../../redux/reduxHooks'
import FamilyHelper from '../../utils/FamilyHelper'
import { renderContent } from '../../utils/helpers'
import AddNewModal from '../../widgets/AddNewModal'
import PersonsList from '../../widgets/PersonList'
import BreastFeeding from './BreastFeeding'
import ChildQuestions from './ChildQuestions'

const Children = () => {
  const { addChild } = useActions()
  const config =
    useSelector((state) => {
      return get(state, [
        'configuration',
        'sectionConfig',
        'your-family',
        'subSectionConfig',
        'children',
        'questions',
      ])
    }) || []
  const persons = usePersons() || {}
  const relationships = useSelector((state) => state.questionnaire.relationships) || []
  const probandId = useSelector((state) => state.questionnaire.probandId) || ''

  const [children, setChildren] = useState([])
  const [childId, setChildId] = useState('')
  const [isOpen, setIsOpen] = useState(false)
  const addedNewChild = useRef(false)

  RemoveLoadingHook()

  useEffect(() => {
    const newIds = getChildPersonIds(probandId)
    if (addedNewChild.current) {
      openModal(difference(newIds, children)[0])
      addedNewChild.current = false
    }
    setChildren(newIds)

    return () => {
      setChildren([])
    }
  }, [persons, relationships])

  return (
    <Container>
      {renderContent({
        renderMap: {
          breastFeeding: <BreastFeeding key="bf" />,
        },
        config,
      })}
      <FormLabel>Please add your biological children (if applicable)</FormLabel>
      <PersonsList personIds={children} openModal={openModal} />
      <AddNewModal
        open={isOpen}
        handleClose={handleClose}
        onSubmit={handleClose}
        dialogTitle="Add Child"
      >
        <ChildQuestions personId={childId} config={config} />
      </AddNewModal>
      <Button
        startIcon={<AddIcon />}
        variant="contained"
        onClick={buttonHandler}
        sx={{ width: 'fit-content' }}
      >
        Add Child
      </Button>
    </Container>
  )

  /**
   * Handle opening a new person modal
   */
  function openModal(clickId) {
    setIsOpen(true)
    setChildId(clickId)
  }

  /**
   * Close modal and clears child id
   */
  function handleClose() {
    setIsOpen(false)
    setChildId('')
  }

  /**
   * Returns a list of all children of the person specified
   * @returns {String[]}
   */
  function getChildPersonIds(id) {
    const childrenList = new FamilyHelper({ persons, relationships }).getChildren(id)

    return flatten(childrenList).map(({ id: _id }) => _id)
  }

  /**
   * Adds a new child member when button is clicked
   */
  function buttonHandler() {
    addChild({ probandId, targetPersonArray: ['proband'] })
    addedNewChild.current = true
  }
}

export { Children }
